import React from "react";
import { Col, Container, Row } from "react-bootstrap";

const Item = (props) => {
  const { col1, col2, col3, summary } = props;
  return (
    <>
      <Container>
        <Row>
          <Col sm={4}>
            <div style={{ fontWeight: "300" }}>{col1}</div>
            <div style={{ fontWeight: "300", fontSize: "1.5rem" }}>{col2}</div>
            <div style={{ fontWeight: "100" }}>{col3}</div>
          </Col>
          <Col sm={8}>
            <div>{summary}</div>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Item;
